import React from "react";
var CheckedContext = /*#__PURE__*/React.createContext();
export var useCheckedContextProps = function useCheckedContextProps(props) {
  var ctx = React.useContext(CheckedContext) || {};
  var individualCheckedControlled = typeof props.checked !== 'undefined';
  var getCheckedValue = function getCheckedValue() {
    if (individualCheckedControlled) {
      return props.checked;
    }
    if (ctx.isChecked) return ctx.isChecked(props.value);
    return false;
  };
  return {
    onChange: function onChange(evt) {
      if (!individualCheckedControlled && ctx.onChange) ctx.onChange(evt);
      if (props.onChange) props.onChange(evt);
    },
    checked: getCheckedValue(),
    value: props.value
  };
};
export var CheckedProvider = CheckedContext.Provider;